import Clarity from "@microsoft/clarity";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router-dom";
import { CLARITY_PROJECT_ID } from "../../../project_config";
import { useAdminGate } from "../../../utils/useAdminGate";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import DashboardSidebar from "../DashboardSidebar";
import WorkshopAdminListSection from "./WorkshopAdminListSection";

export default function AdminWorkshopList() {
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const { ready, isAdmin } = useAdminGate();

	useEffect(() => {
		Clarity.init(CLARITY_PROJECT_ID);
	}, []);

	useEffect(() => {
		const handleResize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	if (!ready) {
		return null;
	}
	if (!isAdmin) {
		return <Navigate to="/login/" replace />;
	}

	return (
		<>
			<Helmet>
				<title>مدیریت کارگاه‌ها | همراهتیم</title>
				<meta name="description" content="مدیریت کارگاه‌های همراهتیم" />
			</Helmet>

			<div className="flex min-h-screen flex-col justify-between bg-[#F0F6FC]">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className="mx-auto max-w-[1200px] px-4">
							<Breadcrumb
								linkDataList={[
									{ label: "خانه", href: "/" },
									{ label: "داشبورد مدیریت", href: "/dashboard/" },
									{
										label: "کارگاه‌ها",
										href: "/dashboard/workshops/",
									},
								]}
							/>
						</div>
					</div>
					<main
						className={[
							"mx-auto flex w-full max-w-[1200px] gap-5 py-8",
							isDesktop ? "flex-row px-4" : "flex-col p-[10px]",
						].join(" ")}
					>
						<DashboardSidebar isDesktop={isDesktop} />
						<WorkshopAdminListSection />
					</main>
				</div>
				<Footer isDesktop={isDesktop} />
			</div>
		</>
	);
}
